var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/components/cosmic/utils/background-utils.ts
import { match } from "ts-pattern";
function generateOrbs(variant, customOrbs, count) {
  if (customOrbs) {
    return customOrbs;
  }
  const baseOrbs = [
    {
      size: "600px",
      color: "from-purple-9/30 to-violet-9/20",
      opacity: 0.5,
      blur: "blur-[100px]",
      animationDelay: 0,
      position: { x: 20, y: 10 },
      glowIntensity: 1.2
    },
    {
      size: "500px",
      color: "from-blue-9/25 to-indigo-9/20",
      opacity: 0.4,
      blur: "blur-[80px]",
      animationDelay: 2,
      position: { x: 70, y: 60 },
      glowIntensity: 1
    },
    {
      size: "400px",
      color: "from-pink-9/20 to-plum-9/15",
      opacity: 0.3,
      blur: "blur-[60px]",
      animationDelay: 4,
      position: { x: 40, y: 80 },
      glowIntensity: 0.8
    },
    {
      size: "700px",
      color: "from-purple-9/35 to-violet-9/25",
      opacity: 0.6,
      blur: "blur-[120px]",
      animationDelay: 6,
      position: { x: 30, y: 80 },
      glowIntensity: 1.5
    },
    {
      size: "550px",
      color: "from-indigo-9/28 to-blue-9/18",
      opacity: 0.45,
      blur: "blur-[90px]",
      animationDelay: 8,
      position: { x: 50, y: 40 },
      glowIntensity: 1.1
    }
  ];
  const colors = [
    "from-purple-9/30 to-violet-9/20",
    "from-blue-9/25 to-indigo-9/20",
    "from-pink-9/20 to-plum-9/15",
    "from-indigo-9/28 to-blue-9/18",
    "from-violet-9/25 to-purple-9/20",
    "from-plum-9/22 to-pink-9/18"
  ];
  if (count !== void 0 && count > baseOrbs.length) {
    const additionalOrbs = [];
    for (let i = baseOrbs.length; i < count; i++) {
      const colorValue = colors[i % colors.length] ?? colors[0] ?? "#3b82f6";
      additionalOrbs.push({
        size: `${Math.floor(Math.random() * 200) + 400}px`,
        color: colorValue,
        opacity: Math.random() * 0.3 + 0.3,
        blur: `blur-[${Math.floor(Math.random() * 40) + 60}px]`,
        animationDelay: i * 2,
        position: {
          x: Math.random() * 80 + 10,
          y: Math.random() * 80 + 10
        },
        glowIntensity: Math.random() * 0.5 + 0.8
      });
    }
    return [...baseOrbs, ...additionalOrbs];
  }
  if (count !== void 0) {
    return baseOrbs.slice(0, count);
  }
  return match(variant).with("minimal", () => baseOrbs.slice(0, 1)).with("dramat\
ic", () => baseOrbs.slice(0, 4)).otherwise(() => baseOrbs.slice(0, 3));
}
__name(generateOrbs, "generateOrbs");
function generateRandomStars(count) {
  const validCount = Math.max(0, Math.min(1e3, Math.floor(count || 0)));
  if (validCount === 0) {
    return [];
  }
  return Array.from({ length: validCount }, (_, i) => ({
    id: i,
    x: Math.random() * 100,
    y: Math.random() * 100,
    size: Math.random() * 2 + 1,
    delay: Math.random() * 3
  }));
}
__name(generateRandomStars, "generateRandomStars");
export {
  generateOrbs,
  generateRandomStars
};
